import {
  getAccessTokenInfo,
  getCompanyTokenInfo
} from "../apis/auth";

export const getMyType = () => {
  try {
    const companyInfo = getCompanyTokenInfo();
    return companyInfo.type;
  } catch (error) {
    return false;
  }
};
// 매니저 타입 검사
// 접근회사에 내가 매니저로 들어왔는지 판단은 store.Profile.isManaging 
export const isManagingType = (type) => {
  try {
    const companyInfo = getCompanyTokenInfo();
    if (companyInfo.type === companyInfo.companyType) {
      return false;
    }
    return 1 !== companyInfo.type && (!type || (type === companyInfo.type));
  } catch (error) {
    return false;
  }
};
export const isManagerCompany = () => {
  try {
    const companyInfo = getCompanyTokenInfo();
    return 1 !== companyInfo.type;
  } catch (error) {
    return false;
  }
};

export const isAdminCompany = () => {
  try {
    const companyInfo = getCompanyTokenInfo();
    return isAdmin() && companyInfo.type === 9;
  } catch (error) {
    return false;
  }
};

export const isTogetherTax = () => {
  try {
    const companyInfo = getCompanyTokenInfo();
    return [100001, 100002].includes(companyInfo.managerCompanyIdx);
  } catch (error) {
    return false;
  }
};

export const isAdmin = () => {
  try {
    const companyInfo = getCompanyTokenInfo();
    return companyInfo.type === 9;
  } catch (error) {
    return false;
  }
};

export const isTestCompany = () => {
  try {
    const testCompanies = process.env.REACT_APP_TEST_COMPANIES || '';
    const testUsers = process.env.REACT_APP_TEST_USERS || '';
    const testCompanieList = testCompanies.split(",");
    const companyInfo = getCompanyTokenInfo();
    const userInfo = getAccessTokenInfo();
    return testCompanieList.includes(String(companyInfo.companyIdx)) || (testUsers && userInfo.userId === testUsers);
  } catch (error) {
    return false;
  }
};
/* -------------------------------------------

  {
    "companyIdx": 100053,
    "employeeIdx": 368,
    "userIdx": 240,
    "type": 9,
    "companyType": 9,
    "tokenType": "company"
  }
  [type][companyType]
  1: 일반회사
  2: 세무사
  3: 노무사
  9: 경리대행/마스터
  type은 이 회사에 접근한 직원이 어떤 회사의 권한을 가지고 있는지,
  companyType은 대상 회사가 어떤 회사인지 타입입니다.

  크리에이트잇 (1)
  직원 김재환
  본인회사만 1번으로 로그인 가능 (type: 1, companyType: 1)

  동범세무사 (2)
  직원 이동범
  본인회사 로그인 불가능
  담당회사 2번으로 로그인 가능 (type: 2, companyType: 1)

  범준노무사 (3)
  직원 김범준
  본인회사 로그인 불가능
  담당회사 3번으로 로그인 가능 (type: 3, companyType: 1)

  성진경리대행 (9)
  직원 조성진
  본인회사 9번으로 로그인 가능 (type: 9, companyType: 9) / 마스터
  담당회사 9번으로 로그인 가능 (type: 9, companyType: 1)


--------------------------------------------- */